import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import authStates from './auth.reducer'
import mapStates from './map.reducer'
import pointsStates from './points.reducer'
import measurementsStates from './measurements.reducer'

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    authStates,
    mapStates,
    pointsStates,
    measurementsStates
  })

export default createRootReducer
